
import useCart from '@/composables/useCart'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  setup() {
    const { addPromoCode } = useCart()

    const code = ref('')
    const codeError = ref<string | null>('')
    const applyCode = (promoCode: string) => {
      try {
        addPromoCode(promoCode)
      } catch (error) {
        codeError.value = error.message
      }
    }
    const clearCodeError = () => {
      codeError.value = null
    }

    const isInputShown = ref(false)
    const toggleInput = () => {
      isInputShown.value = !isInputShown.value
    }

    return {
      code,
      codeError,
      applyCode,
      clearCodeError,
      isInputShown,
      toggleInput,
    }
  },
})
